/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_Ingest_ErrorInputs */

const es_tools_drive_ingest_error = /** @type {(inputs: Tools_Drive_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ingestar archivos de Drive`)
};

const en_tools_drive_ingest_error = /** @type {(inputs: Tools_Drive_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error ingesting Drive files`)
};

/**
* | output |
* | --- |
* | "Error ingesting Drive files" |
*
* @param {Tools_Drive_Ingest_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_ingest_error = /** @type {((inputs?: Tools_Drive_Ingest_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_Ingest_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_ingest_error(inputs)
	return en_tools_drive_ingest_error(inputs)
});
export { tools_drive_ingest_error as "tools.drive.ingest_error" }